import { useQuery } from "@tanstack/react-query";
import triggerTypesSAService from "services/superadmin/triggerTypesSAService";

export const useGetTriggerTypes = () => {
    return useQuery({
        queryKey: ["getTriggerTypes"],
        queryFn: async () => {
            const response = await triggerTypesSAService.getAll();
            return response.data
        },
    });
};